export const ORDER_API='/api/orders/';
export const STOREFRONT_HEADER='X-Storefront-Session';
export const STOREFRONT_SESSION='guest-2026';
export const SAMPLE_ORDER='GL-10284';
